import { request } from '../../utils/axios';

const certPrefix = '/pcCertification/project';

// ==================== 认证认可项目管理 ====================
export const addCertProject = async (data) => {
  return request.post(`${certPrefix}/add`, data);
};

export const editCertProject = async (data) => {
  return request.post(`${certPrefix}/edit`, data);
};

export const getCertProjectList = async (params) => {
  return request.get(`${certPrefix}/list`, { params });
};

export const getCertProjectDetail = async (params) => {
  return request.get(`${certPrefix}/view`, { params });
};

export const deleteCertProject = async (params) => {
  return request.delete(`${certPrefix}/delete`, { params });
};
